import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ShortListedByHrTeam.css';
import axios from 'axios';
import Select from 'react-select';

const ShortListedByshortlistTeam = () => {
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [remark, setRemark] = useState('');
    const [jobOptions, setJobOptions] = useState([]);
    const [profileOptions, setProfileOptions] = useState([]);
    const [selectedJob, setSelectedJob] = useState(null);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [formErrors,] = useState({});
    const statusOptions = [
        { id: 1, value: 'Approved', label: 'Approved' },
        { id: 2, value: 'Rejected', label: 'Rejected' }
    ];
    const [isJobFocused, setIsJobFocused] = useState(false);
    const isJobLabelFloated = isJobFocused || !!selectedJob;
     const [isProfileFocused, setIsProfileFocused] = useState(false);
    const isProfileLabelFloated = isProfileFocused || !!selectedProfile;
     const [isStatusFocused, setIsStatusFocused] = useState(false);
    const isStatusLabelFloated = isStatusFocused || !!selectedStatus;
    const navigate = useNavigate();
    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
        localStorage.setItem('remark', remark);
    };
    const handleProfileChange = (selectedOption) => {
        setSelectedProfile(selectedOption);
        localStorage.setItem('selectedProfileId', selectedOption?.label);
        localStorage.setItem('selectedProfileIdValue', selectedOption?.value);
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/job-openings`)
            .then(response => {
                const jobs = response.data.map(job => ({
                    value: job.jobId,
                    label: `${job.jobId} - ${job.positionName}`
                }));
                setJobOptions(jobs);
            })
            .catch(error => console.error('Error fetching job openings:', error));
    }, []);

useEffect(() => {
    if (selectedJob) {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/personal-info/by-job/${selectedJob.value}`)
            .then(response => {
                const processedProfiles = JSON.parse(localStorage.getItem('processedProfiles') || '[]');

                const profiles = response.data
                    .filter(profile => !processedProfiles.includes(profile.profileId))
                    .map(profile => ({
                        value: profile.profileId,
                        label: `${profile.profileId} - ${profile.name}`
                    }));

                setProfileOptions(profiles);
            })
            .catch(error => console.error('Error fetching profiles:', error));
    }
}, [selectedJob]);

const handleSubmit = (statusData) => {
    const data = {
        profileId: selectedProfile?.value,
        remarks: remark,
        jobId: selectedJob?.value,
        status: statusData.status || 'Pending',
    };

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/shortlist`, data)
        .then(response => {
            alert('Data submitted successfully:', response);

            // ✅ Store Rejected profile in processedProfiles
            if (data.profileId) {
                const processedProfiles = JSON.parse(localStorage.getItem('processedProfiles') || '[]');
                if (!processedProfiles.includes(data.profileId)) {
                    processedProfiles.push(data.profileId);
                    localStorage.setItem('processedProfiles', JSON.stringify(processedProfiles));
                }
            }

            // ✅ Clear
            localStorage.removeItem('remark');
            localStorage.removeItem('selectedJobId');
            localStorage.removeItem('selectedJobLabel');
            localStorage.removeItem('selectedStatus');
            localStorage.removeItem('selectedProfileId');
            localStorage.removeItem('selectedProfileIdValue');

            setRemark('');
            setSelectedJob(null);
            setSelectedProfile(null);
            setSelectedStatus(null);
        })
        .catch(error => {
            console.error('Error submitting data:', error);
        });
};





    const handleNext = () => {
        if (!selectedProfile || !remark) {
            alert("Please fill in all required fields before proceeding.");
            return;
        }

        // Store current form data
        localStorage.setItem('remark', remark);
        localStorage.setItem('selectedJobId', selectedJob?.value);
        localStorage.setItem('selectedJobLabel', selectedJob?.label);
        localStorage.setItem('selectedStatus', selectedStatus?.value || '');

        navigate('/interview');
    };
    useEffect(() => {
        const storedRemark = localStorage.getItem('remark');
        const storedJobId = localStorage.getItem('selectedJobId');
        const storedJobLabel = localStorage.getItem('selectedJobLabel');
        const storedStatus = localStorage.getItem('selectedStatus');
        const storedProfileId = localStorage.getItem('selectedProfileId');
        const storedProfileValue = localStorage.getItem('selectedProfileIdValue');

        if (storedRemark) setRemark(storedRemark);
        if (storedJobId && storedJobLabel) {
            setSelectedJob({ value: storedJobId, label: storedJobLabel });
        }
        if (storedProfileId && storedProfileValue) {
            setSelectedProfile({ value: storedProfileValue, label: storedProfileId });
        }
        if (storedStatus) {
            const status = statusOptions.find(opt => opt.value === storedStatus);
            setSelectedStatus(status || null);
        }
    }, []);


    return (
        <div className='main-div-shortlist'>
            <h2 className='shortlist-name'>Shortlist Round</h2>
            <div className="shortlist-input-label-content-select">
                <label className={`shortlist-floating-label-select ${isJobLabelFloated ? 'label-float-select' : ''}`}><span className=''>JobId</span></label>
                <Select
                    options={jobOptions}
                    value={selectedJob}
                    onChange={(option) => {
                        setSelectedJob(option);
                        setSelectedProfile(null); // ✅ Clear profile when job changes
                        setProfileOptions([]);    // ✅ Optionally clear profile dropdown list to avoid mismatch
                    }}
                    onFocus={() => setIsJobFocused(true)}
    onBlur={() => setIsJobFocused(false)}
    classNamePrefix="react-select"
                    placeholder=" "
                />

            </div>
            <div className="shortlist-input-label-content-select">
                <label className={`shortlist-floating-label-select ${isProfileLabelFloated ? 'label-float-select' : ''}`}><span className=''>ProfileId</span></label>

                <Select
                    options={profileOptions}
                    placeholder=" "
                    value={selectedProfile}
                    onChange={handleProfileChange}
                     onFocus={() => setIsProfileFocused(true)}
                        onBlur={() => setIsProfileFocused(false)}
                        classNamePrefix="react-select"
                />

            </div>
            <div className={`shortlist ${formErrors.surName ? 'did-error-input' : ''}`}>

                <input className="shortlist-input"
                    type="text"
                    placeholder=""
                    onChange={(e) => setRemark(e.target.value)}
                    value={remark} required
                />
                <label className="shortlist-label">HR&nbsp;Remark</label>
            </div>
            <div className="shortlist-input-label-content-select">
                <label className={`shortlist-floating-label-select ${isStatusLabelFloated ? 'label-float-select' : ''}`}><span className=''>Status</span></label>

                <Select
                    placeholder=" "
                    options={statusOptions}
                    value={selectedStatus}
                    onChange={handleStatusChange}
                     onFocus={() => setIsStatusFocused(true)}
                    onBlur={() => setIsStatusFocused(false)}
                    classNamePrefix="react-select"
                    isClearable
                />
            </div>
            <div className="shortlist-btns">
                {selectedStatus?.value === 'Rejected' && (
                    <button className="shortlist-button" onClick={() => handleSubmit({ status: 'Rejected' })}>
                        Submit
                    </button>
                )}
                {selectedStatus?.value === 'Approved' && (
                    <button className="shortlist-button" onClick={handleNext}>
                        Next
                    </button>
                )}
            </div>

        </div>
    );
};
export default ShortListedByshortlistTeam;
